import _ from 'lodash';
import flashmessageTpl from './flashmessage.tpl.html';
import './flash.scss';

import flashMessageService from './flashmessageservice.module';
import {FlashMessageShowDelay, FlashMessageRemoveDelay} from './flashmessageservice.module';

class FlashMessageComponent {
  constructor(FlashMessageService, $timeout, $log) {
    'ngInject';

    this.$timeout = $timeout;
    this.$log = $log;
    this.FlashMessageService = FlashMessageService;

    this.messageList = [];
  }

  $onInit() {
    this.messageList = [];
    this.FlashMessageService.subscribeFlashmessage((message) => {
      this.$timeout(() => this.addMessage(message));
    });
    this.FlashMessageService.subscribeCloseFlashmessage( (msgId) => {
      this.$timeout(() => this.closeFlashMessage(msgId))
    })
  }

  addMessage(message) {
    if (message == null) return;

    message.hidden = true;
    const messageId = message.id;

    this.messageList.unshift(message);
    // Show message after delay so that animations can function properly
    this.$timeout(() => {
      const message = _.find(this.messageList, _.matches({id: messageId}));

      if (message != null) {
        message.hidden = false;
      }
    }, FlashMessageShowDelay);

    // Remove message entirely
    this.$timeout(() => {
      const index = _.findIndex(this.messageList, _.matches({id: messageId}));

      if (index !== -1) {
        this.messageList.splice(index, 1);
      }
    }, FlashMessageRemoveDelay);

  }

  closeFlashMessage(messageId) {
    const index = _.findIndex(this.messageList, _.matches({id: messageId}));
    if (index !== -1) {
      this.messageList.splice(index, 1);
    }
  }

}

const config = {
  templateUrl: flashmessageTpl,
  controller: FlashMessageComponent
};

const mod = angular.module('flashmessages', [flashMessageService])

.component('flashMessages', config);


function appendFlashMessage($document, $compile, $rootScope, FlashMessageElementId) {
  'ngInject';

  const flash = $document.find('flash-messages');
  // Make sure the element is not built multiple times
  if (flash.length > 0) {
    return;
  }

  const target_elem = angular.element(document.getElementById(FlashMessageElementId));
  // Get the target element and prepend flash message component if it doesn't exist yet
  target_elem.prepend($compile('<flash-messages></flash-messages>')($rootScope));
}

export {
  appendFlashMessage,
};

export default mod.name;
